import { useState } from "react";

const CustomTooltip = (props) => {
    const {textContent} = props;
    const [visible, setVisible] = useState(false);

    return (
        <div className="custom-tooltip-wrapper">
        <i class="bi bi-info-circle-fill tooltip-icon" onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}></i>
        {visible && (
            <div className="tooltip-content">
            {textContent}
            </div>
        )}
        </div>
    );
};

export default CustomTooltip;